module.exports = __webpack_public_path__ + "wake-white.svg?431f13b10354fddd8a6ec44451b345be";